import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UriModule } from '®shared/url-utils';

import { OnlineResourceButtonComponent } from './online-resource-button.component';

@NgModule({
  imports: [CommonModule, UriModule],
  declarations: [OnlineResourceButtonComponent],
  exports: [OnlineResourceButtonComponent],
})
export class OnlineResourcesModule {}
